import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
  RowsBox:{
    height:65,
    maxWidth:340,
    width:'100%',
    bottom:'40px',
    left:0,
    right:0,
    margin:'0 auto 0 auto',
    position:'relative'
  }
}));
